import React from "react";
import * as PropTypes from "prop-types";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import { deleteUserAction } from "../../redux/actions/auth.actions";

class DeleteUserButton extends React.Component {
  state = {
    showConfirmDelete: false
  };

  render() {
    const { deleteUserAction } = this.props;
    const { showConfirmDelete } = this.state;

    return (
      <React.Fragment>
        {showConfirmDelete ? (
          <div className="row">
            <div className="col-12">
              <p>
                <Translate id="deleteWarningText" />
              </p>
            </div>
            <div className="col-3">
              <button
                className="btn btn-primary btn-block"
                type="button"
                onClick={() => deleteUserAction()}
              >
                <Translate id="confirmText" />
              </button>
            </div>
            <div className="col-3">
              <button
                className="btn btn-primary btn-block"
                type="button"
                onClick={() => this.setState({ showConfirmDelete: false })}
              >
                <Translate id="cancelText" />
              </button>
            </div>
          </div>
        ) : (
          <button
            className="btn grey-btn"
            type="button"
            onClick={() => this.setState({ showConfirmDelete: true })}
          >
            <Translate id="deleteAccountText" />
          </button>
        )}
      </React.Fragment>
    );
  }
}

DeleteUserButton.propTypes = {
  deleteUserAction: PropTypes.func
};

export default connect(
  null,
  { deleteUserAction }
)(DeleteUserButton);



// WEBPACK FOOTER //
// ./src/components/DeleteUserButton/DeleteUserButton.jsx